import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="header">
      <div className="header-content">
        <img src="/logo.png" alt="Logo" className="logo" />
        <span className="heading">सांगली शिक्षण संस्था, सांगली</span>
      </div>
    </div>
  );
};

export default Header;
